import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {
    PERMISSION_TALENTS_READ
  } from '../../../constants'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify';
import {clearVacancyCandidates} from '../../../actions/pages/vacancy-page'
import {checkPermission} from '../../common/functions/permissions'
import Table from '../../../tables/reactable/DefaultTable'

class CandidateSearchResult extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onClickOpenBtn = this.onClickOpenBtn.bind(this)
    this.state = {
      itemsPerPage: 10,
      openBtnVisible: true,
      openBtnLabel: 'Suggest'
    }
    this.columns = [
      'AvatarImage',
      'FullName',
      'ProdubNumber',
      'ActiveProfiles'
    ]
    this.columnNames = [
      '',
      'Full name',
      'Number',
      'Active profiles'
    ]
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  onClickOpenBtn(navValue, e) {
    let url = 'vacancies/' + this.props.vacancyId + '/skillvendors/' + navValue + '/suggest'

    this.props.ajax.put(url, null, null, () => {
      this.props.clearVacancyCandidates();
      this.props.notify('The candidate was suggested.');
    })
  }

  render() {
    let items = this.props.items.map(item => {
      return Object.assign({}, item, {
        AvatarImage: item.AvatarImageUrl ? (<img src={item.AvatarImageUrl} style={{width: '50px'}} className="rounded-circle" alt="" />) : (null),
        FullName: checkPermission(PERMISSION_TALENTS_READ)
          ? (<a href={'/talents/' + item.Id + '/overview'}>{item.FullName}</a>)
          : (<span>{item.FullName}</span>)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          searchVisible={false}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          onClickOpenBtn={this.onClickOpenBtn}
          sortable={[
            {
              column: 'FullName',
              sortFunction: function(a, b) {
                return a.props.children.localeCompare(b.props.children);
              }
            },
            'ProdubNumber',
            'ActiveProfiles'
          ]}
          defaultSort={{column: 'FullName', direction: 'asc'}}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
  clearVacancyCandidates() { dispatch(clearVacancyCandidates()) }
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(CandidateSearchResult)